import React from "react";
import classes from "./Footer.module.css";
const Footer = () => {
  return (
    <footer className={classes.footer}>
      <p>Copyright &#169; 2023</p>
    </footer>
  );
};
export default Footer;
